/**
  * 判断是否为Null
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
function isNull (obj) {
  return obj === null
}

module.exports = isNull



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isNull.js
// module id = rOs0
// module chunks = 141